/**
 * Read server-rendered bootstrap payload injected by the Worker.
 */
export function getSsrPayload() {
  if (typeof window === 'undefined') return null;
  const data = window.__INITIAL_DATA__;
  if (!data || typeof data !== 'object') return null;
  return data;
}

export function clearSsrPayload() {
  if (typeof window === 'undefined') return;
  try {
    delete window.__INITIAL_DATA__;
  } catch {
    window.__INITIAL_DATA__ = undefined;
  }
}

export function hasSsrMeta() {
  if (typeof document === 'undefined') return false;
  const canonical = document.querySelector('link[rel="canonical"]');
  return Boolean(canonical?.getAttribute('href'));
}
